import _extends from '../../../../../../@babel/runtime/helpers/esm/extends.js';
import { forwardRef, useEffect, createElement } from 'react';
import 'react-dom';
import { Slot as $5e63c961fc1ce211$export$8c6ed5c666ac1360 } from '../../../../../react-slot/dist/index.module.js';
const $8927f6f2acc4f386$var$NODES = ['a', 'button', 'div', 'form', 'h2', 'h3', 'img', 'input', 'label', 'li', 'nav', 'ol', 'p', 'span', 'svg', 'ul']; // Temporary while we await merge of this fix:
// https://github.com/DefinitelyTyped/DefinitelyTyped/pull/55396
// prettier-ignore
/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/
const $8927f6f2acc4f386$export$250ffa63cdc0d034 = $8927f6f2acc4f386$var$NODES.reduce((primitive, node) => {
  const Node = /*#__PURE__*/forwardRef((props, forwardedRef) => {
    const {
      asChild: asChild,
      ...primitiveProps
    } = props;
    const Comp = asChild ? $5e63c961fc1ce211$export$8c6ed5c666ac1360 : node;
    useEffect(() => {
      window[Symbol.for('radix-ui')] = true;
    }, []);
    return /*#__PURE__*/createElement(Comp, _extends({}, primitiveProps, {
      ref: forwardedRef
    }));
  });
  Node.displayName = `Primitive.${node}`;
  return {
    ...primitive,
    [node]: Node
  };
}, {});
export { $8927f6f2acc4f386$export$250ffa63cdc0d034 as Primitive };
//# sourceMappingURL=index.module.js.map
